export default __webpack_public_path__ + "images/0948e4b39f728845ce038cb61bfa445b-snake-game.svg";